export default "__VITE_ASSET__C_nAnQ7Z__"